import React from "react";
import {connect} from "react-redux";
import ClerkRoundStartSetOpeningBidCmp from "./ClerkRoundStartSetOpeningBidCmp";
import ClerkRoundStartUpdateOpeningBidCmp from "./ClerkRoundStartUpdateOpeningBidCmp";
import ClerkRoundBiddingWithBidsReceivedCmp from "./ClerkRoundBiddingWithBidsReceivedCmp";
import ClerkRoundStopInfoCmp from "./ClerkRoundStopInfoCmp";
import ClerkRoundChoiceLotsSelectConfirmCmp from "./ClerkRoundChoiceLotsSelectConfirmCmp";
import {ReduxActiveWebcastSubStateType} from "@nextlot/core/webcast/redux/reducerActiveWebcast";
import {ReduxWebcastCurrentRoundType} from "@nextlot/core/webcast/redux/webcast/reducerWebcastCurrentRound";
import {ReduxWebcastCurrentRoundBiddingType} from "@nextlot/core/webcast/redux/webcast/reducerWebcastCurrentRoundBidding";
import {WebcastStateEnum} from "@nextlot/core/webcast/data/WebcastDataDomain";


type RootCmpPropsType = {
    webcastStatusState: number,
    webcastStatusPaused: boolean,
    currentRound: ReduxWebcastCurrentRoundType,
    currentRoundBidding: ReduxWebcastCurrentRoundBiddingType,
};



function renderContent(props:RootCmpPropsType) {
    if (props.webcastStatusState === WebcastStateEnum.WEBCAST_STATE__ROUND_STOPPING_TRANSITIONAL) {
            // round is stopping
            return <ClerkRoundStopInfoCmp />
        }
        else if (props.webcastStatusState === WebcastStateEnum.WEBCAST_STATE__DURING_ROUND_BIDDING) {

            if (props.currentRoundBidding.highestBid) {
                // we have bids!
                return <ClerkRoundBiddingWithBidsReceivedCmp />
            }
            else if (props.currentRoundBidding.askingBidValue) {
                // we're looking for an opening + first bid
                return <ClerkRoundStartUpdateOpeningBidCmp />
            }
            else {
                // should NEVER get here!
                return <h1 style={{ color: 'red' }}>Invalid state! (CBA#48)</h1>
            }
        }
        else if (props.webcastStatusState === WebcastStateEnum.WEBCAST_STATE__CHOICE_ROUND_LOTS_SELECT) {
            // Choice round: select lots
            return <ClerkRoundChoiceLotsSelectConfirmCmp
                currentRound={props.currentRound}
                currentRoundBidding={props.currentRoundBidding}
            />
        }
        else {
            // BETWEEN_ROUNDS: no asking bid, and no bids placed
            // => we're about to start the round
            return <ClerkRoundStartSetOpeningBidCmp
                currentRoundId={props.currentRoundBidding.roundId}
            />
        }
}


function renderPauseOverlay(paused:boolean) {
    if (! paused) {
        return null;
    }

    return (
        <div className="overlay-busy">
            <h3>Event paused</h3>
        </div>
    )
}



function ClerkBiddingAreaLayoutRootCmp(props:RootCmpPropsType) {
    return (
        <React.Fragment>
            {renderPauseOverlay(props.webcastStatusPaused)}
            {renderContent(props)}
        </React.Fragment>
    )
}



export default connect(({ activeWebcast }: {activeWebcast:ReduxActiveWebcastSubStateType}) => {
    return {
        webcastStatusState: activeWebcast.webcastStatus.state,
        webcastStatusPaused: activeWebcast.webcastStatus.paused,
        currentRound: activeWebcast.webcastCurrentRound,
        currentRoundBidding: activeWebcast.webcastCurrentRoundBidding,
    };
})(ClerkBiddingAreaLayoutRootCmp);


